export default {
  GalacticWarriorGame: {
    Title: 'Trò chơi Chiến binh thiên hà',
    DescriptionPlayNow:
      'Hóa thân thành một <b>Siêu chiến binh</b>, thu thập <b>đá sức mạnh</b> <br/> để chống lại <b>người ngoài hành tinh</b> nhé!',
    DescriptionPlayContinue:
      'Bạn chưa làm xong nhiệm vụ lần đầu <br/> nhấn tiếp tục để hoàn thành sứ mệnh chiến binh ngay nào!',
    DescriptionPlayCompleted:
      'Bạn đã hoàn thành nhiệm vụ lần này rồi <br/> bạn có muốn thử sức lần nữa?',
    ExitGameTitle: 'Các chiến binh sẽ nhớ bạn...',
    ExitGameDescription:
      'Bạn có chắc chắn muốn thoát khỏi <br/> Chiến binh thiên hà?',
    PowerStone: 'Nhận được {powerScore} sức mạnh',
    PowerStoneDescription:
      'Có vẻ bạn đang gặp rắc rối với các thử thách <br/> hãy cố gắng lên nhé!',
    PowerScore: '+{powerScore}',
    PickWarrior: 'Lựa chọn Chiến binh',
    PreviousResult: 'Kết quả lần trước đó',
    EncouragementOneStar: 'Bạn là một chiến binh dũng cảm',
    EncouragementTwoStar: 'Bạn là một chiến binh đáng gờm',
    EncouragementThreeStar: 'Bạn là một chiến binh xuất sắc',
    Exactly: 'Chính xác',
    NotExactly: 'Chưa chính xác',
    TimeOut: 'Hết giờ',
    Congratulation: 'Chúc mừng',
    RankingQuestion:
      'Xếp hạng <span class="text-game-yellow">{rankQuestion}</span> <br/> ngay sau <span class="text-game-green">{previousName}</span>',
    WarningSelectHero: 'Vui lòng chọn Chiến binh thiên hà!',
    PlaceholerAnswerFill: 'Điền vào chỗ trống ...',
    GoStart: 'Bắt đầu!',
    RankNumOne: 'Xếp hạng <span class="text-game-yellow">1</span>',
    AnswerFill: 'Đáp án: {answersQuestion}',
    AnswerFillItem:
      '<span class="text-game-green">({sortOrder})</span> {answerItem}; ',
    NextTryQuestion: 'Câu tiếp',
    PreviousTryQuestion: 'Câu trước',
    GameTime: 'Thời gian:<b> {minute}:{second} </b>'
  }
}
